/* eslint-disable consistent-return */
/* eslint-disable import/prefer-default-export */
import {
  JOIN_WAITLIST_START,
  JOIN_WAITLIST_SUCCESS,
  JOIN_WAITLIST_ERROR,
  REMOVE_WAITLIST_START,
  REMOVE_WAITLIST_SUCCESS,
  REMOVE_WAITLIST_ERROR,
  REMOVE_WAITLIST_START_SCHOOL_DIR,
  REMOVE_WAITLIST_SUCCESS_SCHOOL_DIR,
  REMOVE_WAITLIST_ERROR_SCHOOL_DIR,
} from '../constants';

import fetchErrorHandler from '../services/fetchErrorHandler';
import { getCsrfToken } from '../utils/helpers';
import { updateQuestionsAnswers } from './student';

export const joinWaitlist = (directoryProgram, schoolId, isWaitlistJoinable, programData = null) => async (
  dispatch,
  getState,
  { fetch },
) => {
  const { apiVersion } = getState().runtime;
  const { applicationId } = getState().user;
  const { locale } = getState().intl;
  const data = {
    directory_program: directoryProgram,
    application: applicationId,
    guardian: getState().user.guardianId,
  };
  const saveUrl = `${locale}/api/${apiVersion}/application/${applicationId}/waitlist-programs/`;
  const urlParameters = Object.entries(data)
    .map(e => `${encodeURIComponent(e[0])}=${encodeURIComponent(e[1])}`)
    .join('&');
  if (isWaitlistJoinable) {
    dispatch({ type: JOIN_WAITLIST_START });

    return fetch(saveUrl, {
      credentials: 'include',
      headers: {
        'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'X-CSRFToken': getCsrfToken(),
      },
      method: 'POST',
      body: urlParameters,
    })
      .then(fetchErrorHandler)
      .then(resp => resp.json())
      .then(async respData => {
        await updateQuestionsAnswers()(dispatch, getState, { fetch });
        await dispatch({
          type: JOIN_WAITLIST_SUCCESS,
          payload: { applicationId, id: directoryProgram, schoolId, respData, programData },
        });
      })
      .catch(error => {
        dispatch({
          type: JOIN_WAITLIST_ERROR,
          payload: {
            error,
          },
        });
      });
  }
};

export const removeFromWaitlist = (programId, waitlistId, joinedWaitlist = false, schoolId = 0) => async (
  dispatch,
  getState,
  { fetch },
) => {
  const { apiVersion } = getState().runtime;
  const { applicationId } = getState().user;
  const { locale } = getState().intl;

  const {
    user: { studentWaitlists },
  } = getState();
  const newWaitlistResults = studentWaitlists.results.filter(id => programId !== id);
  let newWaitlistEntities = {};
  newWaitlistResults.map(id => {
    newWaitlistEntities = { ...newWaitlistEntities, [id]: { ...studentWaitlists.entities.waitlists[id] } };
  });
  const deleteUrl = `${locale}/api/${apiVersion}/application/${applicationId}/waitlist-programs/${waitlistId}/`;
  if (!joinedWaitlist) {
    dispatch({ type: REMOVE_WAITLIST_START });
    return fetch(deleteUrl, {
      credentials: 'include',
      headers: {
        'X-CSRFToken': getCsrfToken(),
      },
      method: 'DELETE',
    })
      .then(fetchErrorHandler)
      .then(() => {
        dispatch({
          type: REMOVE_WAITLIST_SUCCESS,
          payload: { newWaitlistResults, newWaitlistEntities, id: programId, waitlistId, schoolId },
        });
        /*
          calling while removing a program from a waitlist, in future we can remove reload and can handle the Component state using Redux.
        */
        window.location.reload();
      })
      .catch(error => {
        dispatch({
          type: REMOVE_WAITLIST_ERROR,
          payload: {
            error,
          },
        });
      });
  }
};

export const removeFromWaitlistSchoolDirectory = (
  programId,
  waitlistId,
  joinedWaitlist = false,
  schoolId = 0,
) => async (dispatch, getState, { fetch }) => {
  const { applicationId } = getState().user;
  const { locale } = getState().intl;
  const deleteUrl = `${locale}/api/v1/application/${applicationId}/waitlist-programs/${waitlistId}/`;
  if (!joinedWaitlist) {
    dispatch({ type: REMOVE_WAITLIST_START_SCHOOL_DIR });
    return fetch(deleteUrl, {
      credentials: 'include',
      headers: {
        'X-CSRFToken': getCsrfToken(),
      },
      method: 'DELETE',
    })
      .then(fetchErrorHandler)
      .then(() => {
        dispatch({
          type: REMOVE_WAITLIST_SUCCESS_SCHOOL_DIR,
          payload: { id: programId, waitlistId, schoolId },
        });
      })
      .catch(error => {
        dispatch({
          type: REMOVE_WAITLIST_ERROR_SCHOOL_DIR,
          payload: {
            error,
          },
        });
      });
  }
};
